module.exports = __webpack_public_path__ + "static/surface-rupture-map2-a0cb7d2fbbc1cefc3e4e924b97d741c2.jpg";